/* eslint-disable */
import Helper from '../helper';
import SearchBoxMessages from "./SearchBox.messages";

const searchBoxValidation = {
    validateSearchPara(searchPara){

        let validation = {showAlert:false,message:'',errorCode:0};
    if(searchPara.trip!='M' && searchPara.totalSector==undefined){
        //**Origin an destination
        let originIsLessThan3 = searchPara.origin==null || searchPara.origin.length < 3;
        let destinationIsLessThan3 = searchPara.destination==null || searchPara.destination.length < 3;

        if (originIsLessThan3){
            validation.showAlert = true;
            validation.message = this.getValidationMessage(1);
            validation.errorCode = 1;
            return validation;
        }

        if (destinationIsLessThan3){
            validation.showAlert = true;
            validation.message = this.getValidationMessage(2);
            validation.errorCode = 2;
            return validation;
        }
        
        if (!Helper.dateAndTime.isValidISODate(searchPara.departureDate)){
            validation.showAlert = true;
            validation.message = this.getValidationMessage(3);
            validation.errorCode = 3;
            return validation;                
        }

        if (!Helper.dateAndTime.isValidISODate(searchPara.returnDate) && searchPara.trip==true){
            validation.showAlert = true;
            validation.message = this.getValidationMessage(4);
            validation.errorCode = 4;
            return validation;                
        }

        if (!this.returnDateIsNotBeforeDepartureDate(searchPara.departureDate,searchPara.returnDate) && searchPara.trip == true){
            validation.showAlert = true;
            validation.message = this.getValidationMessage(5);
            validation.errorCode = 5;
            return validation;             
        }
    }else{
        if(searchPara.totalSector!=searchPara.originM.length)
        {   
            if(searchPara.totalSector<=searchPara.originM.length){}else{         
            validation.showAlert = true;
            validation.message = this.getValidationMessage(1);
            validation.errorCode = 1;
            return validation;
            }
        }
        if(searchPara.totalSector!=searchPara.destinationM.length)
        {
            if(searchPara.totalSector<=searchPara.destinationM.length){}else{
            validation.showAlert = true;
            validation.message = this.getValidationMessage(2);
            validation.errorCode = 1;
            return validation;
            }
        }
        if(searchPara.totalSector!=searchPara.departureDateM.length)
        {
            if(searchPara.totalSector<=searchPara.departureDateM.length){}else{
            validation.showAlert = true;
            validation.message = this.getValidationMessage(3);
            validation.errorCode = 1;
            return validation;
            }
        }
        for (let i = 0; i < searchPara.totalSector; i++){
            let originIsLessThan3 = searchPara.originM[i]==null || searchPara.originM[i]==undefined || searchPara.originM[i].length < 3;
            let destinationIsLessThan3 = searchPara.destinationM[i]==null || searchPara.destinationM[i]==undefined || searchPara.destinationM[i].length < 3;

            if (originIsLessThan3){
                validation.showAlert = true;
                validation.message = this.getValidationMessage(1);
                validation.errorCode = 1;
                return validation;
            }
    
            if (destinationIsLessThan3){
                validation.showAlert = true;
                validation.message = this.getValidationMessage(2);
                validation.errorCode = 2;
                return validation;
            }
        }

        
        for (let i = 0; i < searchPara.totalSector; i++){
            
            let date1=searchPara.departureDateM[i];
            let m1 = parseInt( date1.split("-")[0] + date1.split("-")[1] + date1.split("-")[2]);
            for(let j=i;j<searchPara.totalSector;j++){
                let date2 = searchPara.departureDateM[j];
                if (date2==undefined){
                    //this.searchPara.departureDateM[i] = date1;
                }else {
                    if (date2.length==10){
                        let m2 = parseInt(date2.split("-")[0] + date2.split("-")[1] + date2.split("-")[2]);
                        if (m1>m2){
                            validation.showAlert = true;
                            validation.message = this.getValidationMessage(3);
                            validation.errorCode = 1;
                            return validation;
                        }
                    }
                }
            }               
                
            
        }
    }

        if ((searchPara.adtPassengerCount+searchPara.stuPassengerCount)<=0){
            validation.showAlert = true;
            validation.message = this.getValidationMessage(6);
            validation.errorCode = 6;
            return validation;             
        }
        // if(searchPara.airline.trim()!="" && searchPara.airline.trim()!="--"){
        //     let str = searchPara.airline.trim();
        //     if(/^[a-zA-Z0-9]+$/.test(str)==false){
        //         validation.showAlert = true;
        //         validation.message = this.getValidationMessage(7);
        //         validation.errorCode = 7;
        //         return validation;
        //     }
        // }

        return validation;
    },
    returnDateIsNotBeforeDepartureDate(isoDateStringOfDeparture, isoDateStringOfReturn){
        let tDateDp = Helper.dateAndTime.convertISODateStringToDate(isoDateStringOfDeparture);
        let tDateRt = Helper.dateAndTime.convertISODateStringToDate(isoDateStringOfReturn);

        if (tDateDp>tDateRt){
            return false;
        }else{
            return true;
        }
    },
    getValidationMessage(id){
        let keys = [
            "invalidOrigin",
            "invalidDestination",
            "invalidDepartureDate",
            "invalidReturnDate",
            "departureDateLaterThanReturnDate",
            "passengerNoNotSpecified"];

        return SearchBoxMessages.validationErrorMessages[keys[id-1]];
    }     
};

export default searchBoxValidation;